<template>
    <div 
        class="component--element-image"
        :class="[
            data.position ? 'content-float--' + data.position : 'content-float--center',
            data.collapsed ? 'is-' + data.collapsed : null,
            data.backgroundColor ? 'has-bg' : 'no-bg'
        ]" 
    >
        <div 
            :class="[
                'float',
                data.position ? 'float--' + data.position : 'float--center',
            ]" 
            :style="{
                '--bg-color': data.backgroundColor,
                '--image-h': imageH ? imageH + 'px' : null
            }"
        >
            <div class="container">
                <div class="row" >
                    <div v-if="data.items" class="col-xs-12 col-sm-12 col-xl-10 col-xl-offset-1">
                        <div class="row">
                            <div v-for="(item, index) in data.items" 
                            :key="index" :data_index="index" :class="item.width">
                                <div class="float-elem relative">
                                    <PinButton
                                        v-if="data.showPinterestButton"
                                        :imageURL="item.image"
                                        :imageDescription="item.imageTitle"
                                    ></PinButton>
                                    
                                    <img @load="onImgLoad" class="image-item" :src="item.image" alt="item.title" ref="image">
                                    <div class="content" 
                                        v-if="data.showTitle || item.content || item.buttonTitle"
                                    >
                                        <h4 v-if="data.showTitle" v-animate="'slide-up'" class="title delay-1">{{ item.title }}</h4>
                                        <div v-if="item.content" v-html="item.content" v-animate="'slide-up'" class="delay-2"></div>
                                        
                                        <a
                                            v-animate="'slide-up'"
                                            v-if="item.buttonTitle"
                                            class="button button--solid-black delay-3"
                                            :href="item.link"
                                            :aria-label="item.buttonTitle"
                                            :title="item.buttonTitle"
                                        >
                                            {{item.buttonTitle}}
                                        </a>
                                    </div>

                                    <FavButton v-if="data.showFavButton" :imageID="item.imageID"></FavButton>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else class="col-xs-12 col-sm-12 col-xl-10 col-xl-offset-1">
                        <div class="float-elem relative">
                            <PinButton
                                v-if="data.showPinterestButton"
                                :imageURL="data.image"
                                :imageDescription="data.imageTitle"
                            ></PinButton>
                            
                            <img @load="onImgLoad" class="image-item" :src="data.image" alt="data.title" ref="image">
                            <div class="content" 
                                v-if="data.showTitle || data.description || data.buttonTitle"
                            >
                                <h4 v-if="data.showTitle" v-animate="'slide-up'" class="title delay-1">{{ data.title }}</h4>
                                <div v-if="data.description" v-html="data.description" v-animate="'slide-up'" class="delay-2"></div>
                                
                                <a
                                    v-animate="'slide-up'"
                                    v-if="data.buttonTitle"
                                    class="button button--solid-black delay-3"
                                    :href="data.link"
                                    :aria-label="data.buttonTitle"
                                    :title="data.buttonTitle"
                                >
                                    {{data.buttonTitle}}
                                </a>
                            </div>

                            <FavButton v-if="data.showFavButton" :imageID="data.imageID"></FavButton>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PinButton from "../../components/PinButton/PinButton";
    // import { Fragment } from 'vue-fragment';
    import { debounce } from 'vue-debounce'
    import ImageItem from "../Image/ImageItem";
    import FavButton from "../FavButton/FavButon";

    export default {
        name: "element-image",
        components: {
            PinButton,
            // Fragment,
            ImageItem,
            FavButton
        },
        props: {
            data: {
                type: Object
            }
        },
        data() {
            return {
                imageH: null,
            };
        },
        computed: {
            // Pushing a dynamic variable to pseudo element
            cssVars() {
                return {
                    '--bg-color': this.data.backgroundColor
                }
            }
        },
        methods: {
            resizeHandlerEvent() {},
            resizeHandler () {
                if( Array.isArray(this.$refs.image) ) {
                    let h = 0;
                    this.$refs.image.forEach((image, idx) => {
                        if(image.offsetHeight>h){
                            h = image.offsetHeight;
                        }
                    });
                    this.imageH = h;
                }else{
                    this.imageH = this.$refs.image.offsetHeight;
                }
            },
            onImgLoad () {
                this.resizeHandler();
            }
        },
        created() {
            const app = this;
            app.resizeHandlerEvent = debounce(function(){
                app.resizeHandler();
            }, 250);
            window.addEventListener("resize", this.resizeHandlerEvent);
            window.addEventListener("scrollgit", this.resizeHandlerEvent);

            // call this conditionally
            // possible value for this.data.collapsed : collapsed / null
            if(this.data.collapsed==='collapsed'){
                let emitClass = {
                    refIndex: this.data.refIndex,
                    offset: 0,
                    class: null
                };

                if (this.data.position==='top') {
                    emitClass.offset = -1;
                    emitClass.class = 'next-is-collapsed';
                    app.$emit('addNeighbourClass',emitClass);
                }

                if (this.data.position==='bottom') {
                    emitClass.offset = 1;
                    emitClass.class = 'prev-is-collapsed';
                    app.$emit('addNeighbourClass',emitClass);
                }

                if (this.data.position==='center') {
                    emitClass.offset = -1;
                    emitClass.class = 'next-is-collapsed-center';
                    app.$emit('addNeighbourClass',emitClass);

                    emitClass.offset = 1;
                    emitClass.class = 'prev-is-collapsed-center';
                    app.$emit('addNeighbourClass',emitClass);
                }
            }
        },
        destroyed() {
            window.removeEventListener("resize", this.resizeHandlerEvent);
            window.removeEventListener("scrollgit", this.resizeHandlerEvent);
        },
        mounted() {
            this.resizeHandler();
        },  
    };
</script>

<style lang="scss" scoped>
    @import "../../../scss/abstracts/variables";

    .float-elem.relative {
        position: relative;
    }

    .image-item {
        display: block;
    }

    .content {
        margin-top: 3rem;

        :first-child {
            margin-top: 0;
        }

        :last-child {
            margin-bottom: 0;
        }

        .title {
            font-family: $font-primary-med;
            
            @media #{$md} {
            font-size: 1.7143em;
            }
        }

    }

    .button {
        margin-top: 2rem;
    }

    .float--top,
    .float--center,
    .float--bottom {
        position: relative;
        z-index: 1;

        &::after {
            content: "";
            display: block;
            background-color: var(--bg-color);
            width: 100%;
            position: absolute;
            z-index: -1;
        }
    }

    // Image float position top
    .float--top {
        margin-top: 120px;

        @media #{$below-md} {
            margin-top: 2rem;
        }

        &::after {
            height: 100%;
            top: 0;
        }

        .float-elem {
            position: relative;
            top: -120px;

            @media #{$below-md} {
                top: -2rem;
            }
        }
    }

    .float--center {
        padding-top: 120px;
        padding-bottom: 120px;

        @media #{$below-md} {
            padding-top: 2rem;
            padding-bottom: 2rem;
        }

        &::after {
            top: 0;
            bottom: 0
        }
    }

    // Image float position bottom
    .float--bottom {
        padding-top: 120px;

        @media #{$below-md} {
            padding-top: 2rem;
        }

        &::after {
            height: var(--image-h, 600px);
            top: 0;
        }

        .float-elem {
            position: relative;
        }
    }

    // Image float position none
    .float--none {
        position: relative;
        z-index: 1;
        margin-top: 0;

        .float-elem {
            position: relative;
        }
    }


    .component--element-image {
        &.next-is-collapsed {
            margin-bottom: 0 !important;

            .float-elem {
                padding-bottom: 120px;
            }
        }

        &.prev-is-collapsed {
            position: relative;
            z-index: -1;

            .float-elem {
                padding-top: 120px;
            }
        }

        &.is-collapsed {
            &.content-float--top {
                margin-bottom: 0 !important;

                .float--top {
                    margin-top: 0;
                }
            }

            &.content-float--center {
                .float--center {
                    padding-top: 0;
                    padding-bottom: 0;
                }
            }

            &.content-float--bottom {
                .float--bottom {
                    margin-bottom: -120px;
                }
            }
        }
        .row {
            @media #{$below-md} {
                margin-left: -10px;
                margin-right: -10px;
            }

            >div[class*=col-] {
                @media #{$below-md} {
                    padding-left: 10px;
                    padding-right: 10px;
                }
            }
        }
    }
</style>